import currencyCodes from 'currency-codes'

/**
 * ISO 4217 currency code validation
 */
export const isValidCurrencyCode = (value: string): boolean => {
  return currencyCodes
    .codes()
    .some((code: string): boolean => code.toLowerCase() === value.toLowerCase())
}
